import { render, staticRenderFns } from "./ComInfo.vue?vue&type=template&id=6365c0ce&"
import script from "./ComInfo.vue?vue&type=script&lang=js&"
export * from "./ComInfo.vue?vue&type=script&lang=js&"
import style0 from "./ComInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports